import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/lib/Seo";
import { PageHead } from "@/pages/About";

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : "/api";

export default function News() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/news`)
      .then((response) => response.ok ? response.json() : Promise.reject())
      .then(setItems)
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return <>
    <Seo path="/news" title="أخبارنا" description="آخر أخبار سياق وبرامجها وشراكاتها" />
    <PageHead eyebrow="أخبارنا" title="أخبار سياق" subtitle="محطاتنا، برامجنا، وشراكاتنا في صناعة الأثر" />
    <section className="bg-paper py-20 sm:py-24">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        {loading ? <p className="text-blue">جارٍ تحميل الأخبار…</p> : items.length === 0 ? (
          <p className="text-blue">ستُنشر أخبار سياق هنا قريبًا</p>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 border-t border-navy/10">
            {items.map((item) => <Link key={item.id || item.slug} to={`/news/${item.slug}`} className="group block py-8 md:px-7 border-b md:border-l border-navy/10">
              <time className="text-sm text-purple">{item.published_at ? new Date(item.published_at).toLocaleDateString("ar-SA") : ""}</time>
              <h2 className="font-display text-navy text-2xl leading-snug mt-4 group-hover:text-coral transition-colors">{item.title}</h2>
              <p className="text-blue leading-relaxed mt-4">{item.excerpt}</p>
              <span className="inline-flex items-center gap-2 text-coral mt-6">للمزيد <ArrowLeft size={16}/></span>
            </Link>)}
          </div>
        )}
      </div>
    </section>
  </>;
}
